import { atom } from 'jotai';
export const frameImageUrlsAtom = atom<string[]>([]);